import {OperationHandler} from "../../abstract/operation-handler";
import {Mapping} from "../../mapping";

export class MixedHandler extends OperationHandler {
  constructor(mapping: Mapping) {
    super(mapping);
  }

  operate(target: object): PropertyDescriptor {
    // TODO: Implement me!!
    // TODO: Instantiate
    // TODO: Convert
    return null;
  }

}
